var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "plan-selection" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "center", align: "middle" } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 20, md: 16, lg: 12, xl: 10 } },
            [
              _c(
                "el-card",
                { staticClass: "selection-card" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "container", attrs: { span: 23 } },
                        [
                          _c("span", {
                            staticStyle: {
                              width: "100%",
                              height: "10px",
                              position: "absolute",
                              left: "0",
                              top: "0"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "h1",
                            {
                              staticStyle: {
                                "line-height": "50px",
                                "font-size": "30px",
                                "font-weight": "600"
                              }
                            },
                            [_vm._v("Welcome")]
                          ),
                          _vm._v(" "),
                          _c(
                            "h3",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                "line-height": "21px",
                                "margin-bottom": "32px"
                              }
                            },
                            [
                              _vm._v(
                                "Thank you for joining UNIFI Property. Your account has been successfully activated."
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "100%",
                                "text-align": "center",
                                "margin-bottom": "40px"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "sign-in-btn",
                                  attrs: { type: "primary", size: "large" },
                                  on: { click: _vm.goToUConnect }
                                },
                                [_vm._v("Log in to U-Connect")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "h3",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                "line-height": "21px",
                                "margin-bottom": "32px"
                              }
                            },
                            [
                              _vm._v(
                                "We look forward to assisting you on your property journey."
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "line-height": "18px",
                                color: "#5f5f5f",
                                "margin-bottom": "10px"
                              }
                            },
                            [
                              _vm._v(
                                "If you are experiencing any\n              technical difficulties, please contact our support team on\n              "
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "clear",
                                  staticStyle: {
                                    "text-decoration": "underline",
                                    color: "#003333",
                                    "margin-bottom": "16px"
                                  }
                                },
                                [_c("span", [_vm._v("team@unifiproperty.com")])]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35380659", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35380659","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/steps/paymentSteps/uConnectSuccessStep.vue
// module id = null
// module chunks = 